export default __webpack_public_path__ + "static/media/Background.0a4e48d2.png";